import DeleteIcon from "@mui/icons-material/Delete";

export const TradeTab = ({
    tradeData,
    setTradeData,
    errors,
    setErrors,
    handleTabChange,
}) => {

    const addTradeRow = () => {
        setTradeData([
            ...tradeData,
            { trade_company: "", trade_address: "", trade_contact: "" }
        ]);
    };

    const removeTradeRow = (index) => {
        if (tradeData.length > 1) {
            setTradeData(tradeData.filter((_, i) => i !== index));
        }
    };

    const handleTradeChange = (index, field, value) => {
        const updated = tradeData.map((trade, i) =>
            i === index ? { ...trade, [field]: value } : trade
        );
        setTradeData(updated);

        const errorKey = `${field}_${index}`;
        if (errors[errorKey]) {
            setErrors(prev => ({
                ...prev,
                [errorKey]: ""
            }));
        }
    };

    return (
        <div className="tab-pane fade show active">
            <h6 className="border-bottom pb-2 mb-3">Trade Details</h6>

            {tradeData.map((trade, index) => (
                <div
                    key={index}
                    className="border p-3 mb-3 position-relative rounded"
                >
                    {tradeData.length > 1 && (
                        <button
                            type="button"
                            className="btn btn-outline-danger btn-sm position-absolute"
                            style={{ top: "10px", right: "10px" }}
                            onClick={() => removeTradeRow(index)}
                            title="Remove Trade"
                        >
                            <DeleteIcon fontSize="medium" />
                        </button>
                    )}

                    <div className="row mt-2">
                        <div className="col-md-6">
                            <label>Trade Company Name {index + 1} *</label>
                            <input
                                className={`form-control ${errors[`trade_company_${index}`] ? "is-invalid" : ""}`}
                                value={trade.trade_company}
                                onChange={(e) =>
                                    handleTradeChange(index, "trade_company", e.target.value)
                                }
                            />
                            {errors[`trade_company_${index}`] && (
                                <div className="invalid-feedback">
                                    {errors[`trade_company_${index}`]}
                                </div>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label>Trade Contact *</label>
                            <input
                                type="number"
                                className={`form-control ${errors[`trade_contact_${index}`] ? "is-invalid" : ""}`}
                                value={trade.trade_contact}
                                onChange={(e) =>
                                    handleTradeChange(index, "trade_contact", e.target.value)
                                }
                            />
                            {errors[`trade_contact_${index}`] && (
                                <div className="invalid-feedback">
                                    {errors[`trade_contact_${index}`]}
                                </div>
                            )}
                        </div>

                        <div className="col-md-12 mt-2">
                            <label>Trade Address *</label>
                            <textarea
                                className={`form-control ${errors[`trade_address_${index}`] ? "is-invalid" : ""}`}
                                value={trade.trade_address}
                                onChange={(e) =>
                                    handleTradeChange(index, "trade_address", e.target.value)
                                }
                            />
                            {errors[`trade_address_${index}`] && (
                                <div className="invalid-feedback">
                                    {errors[`trade_address_${index}`]}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ))}

            <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={addTradeRow}
            >
                + Add Another Trade
            </button>

            <div className="d-flex justify-content-end gap-3 mt-4">
                <button
                    type="button"
                    className="btn btn-dark btn-sm mr-2"
                    onClick={() => handleTabChange("authorized")}
                >
                    Back
                </button>
                <button
                    type="button"
                    className="btn btn-info btn-sm"
                    onClick={() => handleTabChange("bank")}
                >
                    Next
                </button>
            </div>
        </div>
    );
};
